import type { FC } from 'react'

import styles from './cartError.module.scss'
import classNames from 'classnames'

interface IProps {
  error: string | undefined
  className?: string
}

export const CartError: FC<IProps> = ({ error, className }) => {
  if (!error) return null
  return <p className={classNames(styles.parent, className)}>{error}</p>
}
